import ArticleTemplate from '@/components/feature/ArticleTemplate';
import { allArticles } from '@/mocks/articles';

const article = allArticles.find((a) => a.slug === 'vigorbuy-spreadsheet-for-business')!;

export default function ArticleBusinessPage() {
  return <ArticleTemplate article={article} />;
}